import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import IconButton from "@mui/material/IconButton";
import AddBoxIcon from "@mui/icons-material/AddBox";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import { giveAwayManageActiveTableColumn } from "@/config/tableColumnConfig";
import SaveIcon from "@mui/icons-material/Save";
import CreateSystemSettingGiftDialog from "@/components/Dialog/createSystemSettingGiftDialog";

// Fetch
import {
  activeGiveawayManage,
  updatedactiveGiveawayManage,
} from "@/fetch/fetchGiveaway";

// Moment
import Moment from "moment";
import "moment/locale/zh-hk";
import { extendMoment } from "moment-range";

const SystemSettingGiftPage = (props) => {
  const { open, setOpen } = props;
  const moment = extendMoment(Moment);

  const { date } = useParams();
  const datetime = moment(`${date}-01`).format("YYYY-MM-DD");

  //ref
  const productDataRef = React.useRef([]);

  // Navigate
  const navigate = useNavigate();

  //const fileReader = new FileReader();

  // States
  const [productData, setProductData] = React.useState([]);
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [editCount, setEditCount] = React.useState(0);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const handleOnClickSave = async () => {
    await updatedactiveGiveawayManage(productDataRef.current)
      .then((data) => {
        if (data && data.results) {
          productDataRef.current = [];
          setEditCount((prev) => (prev = 0));
          setSnackMessage(`修改成功`);
        } else {
          setSnackMessage(`修改失敗`);
        }
        setSnackOpen(true);
        setTimeout(() => {
          setSnackOpen(false);
        }, 1500);
      })
      .then(fetchAll);
  };

  const handleCellClickChange = (data, newValue) => {
    let rawData = {
      id: data.row?.id,
      list_datetime: data.row?.list_datetime,
      is_active: data.row?.is_active,
    };

    rawData = { ...rawData, [`${data["field"]}`]: newValue };

    const updatedRows = [...productDataRef.current];

    const tempValue = updatedRows.filter((item) => item.id !== rawData.id);

    tempValue.push(rawData);

    productDataRef.current = tempValue;

    setEditCount((prev) => prev + 1);
  };

  const handleCellClick = (data) => {
    if (data["field"] === "is_active") {
      const tempData = [...productData];
      const index = productData.findIndex((item) => item.id === data.id);
      if (index > -1) {
        tempData[index]["is_active"] = !productData[index]["is_active"];
        handleCellClickChange(data, tempData[index]["is_active"]);
      }
      setProductData(tempData);
    }
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await activeGiveawayManage(datetime).then((data) => {
        if (data && data.results) {
          setProductData(data.data);
        } else {
          setProductData([]);
        }
      });
    } catch (error) {
      setDataTableLoading(false);
    }
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    fetchAll();

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="贈品啟動設定"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Insert Record */}
            <IconButton component="label" onClick={() => setIsDialogOpen(true)}>
              <AddBoxIcon />
            </IconButton>
            {moment(datetime).format("YYYY-MM") >=
              moment().format("YYYY-MM") && (
              <>
                {/* insert Record */}
                {/* <IconButton component="label">
                  <DriveFolderUploadIcon />
                  <input
                    hidden
                    type={"file"}
                    id={"csvFileInput"}
                    accept={".csv"}
                    onChange={(e) => handleOnChangeUpload(e)}
                  />
                </IconButton> */}
              </>
            )}
            {/* Save Record */}
            <IconButton
              component="label"
              disabled={editCount <= 0 ? true : false}
              color={"primary"}
              onClick={() => handleOnClickSave()}
            >
              <SaveIcon />
            </IconButton>
          </div>
        }
      />
      <CreateSystemSettingGiftDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        datetime={datetime}
        setSnackSeverity={setSnackSeverity}
        setSnackOpen={setSnackOpen}
        setSnackMessage={setSnackMessage}
        fetchAll={fetchAll}
        productData={productData}
      ></CreateSystemSettingGiftDialog>
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            // newEditingApi={true}
            rows={productData}
            columns={giveAwayManageActiveTableColumn}
            pageSize={100}
            onCellClick={(param, event) => {
              handleCellClick(param);
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default SystemSettingGiftPage;
